import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../../api";
import type { Book } from "../../api";

export function EditBookButton({ book, onRefresh }: { book: Book; onRefresh?: () => void }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const arr = book.activeReplaceRevision;
  const inflight = !!arr && arr.status !== "failed";
  const failed = !!arr && arr.status === "failed";
  if (book.status !== "ready" || book.archivedAt || book.supersededAt) return null;

  const onEdit = async () => {
    if (busy || inflight) return;
    setBusy(true);
    try {
      const s = await api.startEditSession(book.id);
      if (s.mode === "photos") navigate(`/app/books/${s.draftId}`);
      else navigate(`/app/new/story`, { state: { prefill: s.prefill, revisionOf: s.revisionOf } });
    } catch {
      setBusy(false);
    }
  };

  const onRetry = async () => {
    if (!arr || busy) return;
    setBusy(true);
    try {
      await api.retryBook(arr.id);
      onRefresh?.();
    } finally {
      setBusy(false);
    }
  };

  if (failed) {
    return (
      <button type="button" className="tp-topbtn" disabled={busy} onClick={onRetry} title={t("editBook.regenFailed")}>
        {t("editBook.tryAgain")}
      </button>
    );
  }
  return (
    <button type="button" className="tp-topbtn" disabled={busy || inflight} onClick={onEdit}>
      {inflight ? t("editBook.regenerating", { done: arr!.progress, total: arr!.totalPages }) : t("editBook.edit")}
    </button>
  );
}
